import React, { useContext } from 'react';
import i18next from 'i18next';
import { Textlink } from '../../../../AutostadtTabComponents/Button';
import SubpageBlue from '../../SubpageBlue';
import './styles.scss';
import Textbox from '../../../../AutostadtTabComponents/Tiles/Textbox';
import { Trans } from 'react-i18next';
import { setOverlay } from '../../../../../utils/SspProvider/dispatchFunctions';
import { OverlayEnum } from '../../../../../enums';
import SspProviderContext from '../../../../../utils/SspProvider/context';

export default function Contact() {
    const store = useContext(SspProviderContext);

    return (
        <SubpageBlue
            title={i18next.t('ContactTitle')}
            className='as-contact'
            headerChildren={
                <>
                    <p className='body large'>
                        <Trans
                            i18nKey='AddressAutostadt'
                            components={{
                                strong: <strong />,
                                br: <br />,
                            }}
                        />
                    </p>
                    <p className='body large'>{i18next.t('ContactSubline')}</p>
                    <Textlink
                        type={'svg-left'}
                        color={'white'}
                        text={i18next.t('PhoneNumber')}
                        svg='#as-phone'
                        onClick={() => {
                            const numberWithoutSpaces = i18next.t('PhoneNumber').replace(/\s+/g, '');
                            window.location.href = `tel:${numberWithoutSpaces}`;
                        }}
                    />
                    <Textlink
                        type={'svg-left'}
                        color={'white'}
                        text={i18next.t('ContactEmailAddress')}
                        svg='#as-email'
                        onClick={() => {
                            const email = i18next.t('ContactEmailAddress');
                            window.location.href = `mailto:${email}`;
                        }}

                    />
                </>
            }
        >
            <>
                <Textbox
                    headline={i18next.t('QuestionnaireBoxHeadline')}
                    text={i18next.t('QuestionnaireBoxText')}
                    buttonText={i18next.t('QuestionnaireBoxBtn')}
                    color='white'
                    onClick={() => {
                        setOverlay(store, {
                            enum: OverlayEnum.ExternalContent,
                            media: 'https://autostadt.survalyzer.eu/nrrgodwpvh?l=de',
                        });
                    }}
                />
                <article className='social-media'>
                    <p>{i18next.t('FollowUs')}</p>
                    <div className='social-media-container'>
                        <button
                            onClick={() => {
                                setOverlay(store, {
                                    enum: OverlayEnum.ExternalContent,
                                    media: 'https://www.instagram.com/autostadt/',
                                });
                            }}
                        >
                            <svg>
                                <use xlinkHref='#as-instagram'></use>
                            </svg>
                        </button>
                        <button
                            onClick={() => {
                                setOverlay(store, {
                                    enum: OverlayEnum.ExternalContent,
                                    media: 'https://www.facebook.com/autostadt',
                                });
                            }}
                        >
                            <svg>
                                <use xlinkHref='#as-facebook'></use>
                            </svg>
                        </button>
                        <button
                            onClick={() => {
                                setOverlay(store, {
                                    enum: OverlayEnum.ExternalContent,
                                    media: 'https://www.youtube.com/@autostadt',
                                });
                            }}
                        >
                            <svg>
                                <use xlinkHref='#as-youtube'></use>
                            </svg>
                        </button>
                    </div>
                </article>
            </>
        </SubpageBlue>
    );
}
